import Vue from 'vue';
import store from 'store/store.js'
import Vuex from 'vuex';
import axios from 'axios'
import { prefix_m } from './constant.js';
import miniToastr from 'mini-toastr';

export default class Service{
    static dateBuilder(current_my, day){
        return day >= 10 ? day + '-' + current_my : '0' + day + '-' + current_my;
    }


    static getEmpList() {
        if (store.state.empList==-1){

            axios.get(prefix_m + '/all_employee')
                .then(response => {
                    store.dispatch('setEmpList', response.data.response);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

    static getDebts(day, month, year) {
        if (store.state.debts == -1) {

            axios.get(prefix_m + '/debts/' + this.dateBuilder(month, day) + '-' + year)
                .then(response => {
                    store.dispatch('setDebts', response.data.response);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

    static getTimeTrackigTotal(month, year){
        if (store.state.timeTracking==-1){
            axios.get( prefix_m+'/time_tracking/' +year+"/"+(month+1))
                .then(response => {
                    store.dispatch('setTimeTracking', response.data.response);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
    static getStatuses(){
        if (store.state.statuses == -1) {
            axios.get(prefix_m + '/tasks_stats')
                .then(response => {
                    store.dispatch('setStatuses', response.data.response);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
    static getProjectTotal(month, year) {
        if(store.state.projects==-1){
            axios.get(prefix_m +'/projects/'+year+"/"+(month+1))
                .then(response => {
                    store.dispatch('setProjects', response.data.response);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
    static getTasks(current_my, day, id){
        if (store.state.tasksMonoceros == -1) {
            axios.get(prefix_m + '/tasks/' + this.dateBuilder(current_my, day) + '/' + id)
                .then(response => {
                    store.dispatch('setTasksMonoceros', response.data.response);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
    static getTasksJira(current_my, day, id){
        if (store.state.tasksJira == -1) {
            axios.get(prefix_m + '/tasks_jira/' + this.dateBuilder(current_my, day)  + '/' + id)
                .then(response => {
                    store.dispatch('setTasksJira', response.data.response);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
    static postWriteOff(form_data, is_inside, total_time_count, difference){
        let error_comm = "";
        /*if (!form_data.count != 0 || !form_data.count){
            error_comm += " Не выставлено время.";
        }*/
        if((total_time_count+difference/60)>12){
            error_comm += " Нельзя списать больше 12 часов.";
        }
        if (!form_data.task || form_data.task == -1){
            error_comm += " Не выбрана задача.";
        }
        if (!form_data.status) {
            error_comm += " Не заполнено поле \"Статус\"."
        }
        if(
            form_data.status.old=="Closed" ||
            form_data.status.old=="Resolved" ||
            form_data.status.old=="Done" ||
            form_data.status.old=="Canceled"
        ) {
            error_comm += " Невозможно списать время на задачу со статусом " + form_data.status.old + ".";

            form_data.task = "";
            form_data.count = 0;
            form_data.status = "";
            form_data.comm_made = "";
            form_data.comm_whatremains = "";
            form_data.comm_howmuch = "";
            form_data.comm_problems = "";
        }
        /*if(is_inside === false && form_data.comm_howmuch=="") {
            error_comm += " Не заполнено поле \"Сколько осталось\".";
        }*/

        if (error_comm.length>0){
            alert("Ошибка при вводе данных. " + error_comm);
        }
        else{
            form_data.status = form_data.status.new;
            miniToastr.init();
            if (form_data.track_id){
                axios.post(prefix_m + '/push_time', form_data)
                    .then(response => {
                        miniToastr.info('Данные успешно отправлены');
                        form_data.task = "";
                        form_data.count = 0;
                        form_data.status = "";
                        form_data.comm_made = "";
                        form_data.comm_whatremains = "";
                        form_data.comm_howmuch = "";
                        form_data.comm_problems = "";
                        form_data.track_id = "";
                    })
                    .catch(error => {
                        miniToastr.error('Ошибка при отправке данных');
                        console.log(error);
                    });
            } else {
                axios.post(prefix_m + '/push_time', form_data)
                    .then(response => {
                        miniToastr.info('Данные успешно отправлены');
                        form_data.task = "";
                        form_data.count = 0;
                        form_data.status = "";
                        form_data.comm_made = "";
                        form_data.comm_whatremains = "";
                        form_data.comm_howmuch = "";
                        form_data.comm_problems = "";

                    })
                    .catch(error => {
                        miniToastr.error('Ошибка при отправке данных');
                        console.log(error);
                    });
            }
        }
    }
    static postAuth(login, pass){
        var md5 = require('js-md5');

        axios.post(prefix_m + '/login', { username: login, password: ("md5" + md5.hex(pass+login))})
            .then(response => {
                if (response.data.status) {
                    this.setCookie('fullname', response.data.response.lastname + " " + response.data.response.firstname, {expires: 1209600});
                    location.reload(true);
                }
                else {
                    alert("Неверный логин и/или пароль");
                }
            })
            .catch(function (error) {
                alert("Неверный логин и/или пароль");
                console.log(error);
            });
    }
    static getTimeTrackingProject(project){

    }

    static getCookie(name) {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }
    static deleteCookie(name) {
        this.setCookie(name, null, {
            expires: -1
        });
    }
    static setCookie(name, value, options) {
        options = options || {};

        var expires = options.expires;

        if (typeof expires == "number" && expires) {
            var d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = options.expires = d;
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        value = encodeURIComponent(value);

        var updatedCookie = name + "=" + value;

        for (var propName in options) {
            updatedCookie += "; " + propName;
            var propValue = options[propName];
            if (propValue !== true) {
                updatedCookie += "=" + propValue;
            }
        }

        document.cookie = updatedCookie;
    }

}



// WEBPACK FOOTER //
// ./src/service.js